import React, { Component } from "react"
import Iframe from "react-iframe"

export default class MerchantPageMapSection extends Component {
  render() {
    return (
      <div className="shoppage__textblock">
        <div className="shoppage__textblock__content">
          <h2 data-epi-edit="AboutMerchantHeadline">{this.props.aboutMerchantHeadline}</h2>
          <span dangerouslySetInnerHTML={{ __html: this.props.aboutMerchantText }} data-epi-edit="AboutMerchantText"></span>
          {!this.props.globalHideMap ?? !this.props.hideMap ? (
            <React.Fragment>
              <h3 id={"mapSection"} data-epi-edit="MapHeadline">
                {this.props.mapHeadline?.replace("{name}", this.props.nameCm)}
              </h3>
              <div style={{ width: "100%" }}>
                <Iframe
                  width="100%"
                  height="600"
                  src={`https://maps.google.com/maps?q=${this.props.latitude},${this.props.longitude}&hl=es;z=14&output=embed`}
                ></Iframe>
              </div>
            </React.Fragment>
          ) : (
            ""
          )}
        </div>
      </div>
    )
  }
}
